import './App.css';
import DevploperDetail from './Components/Developer/DeveploperDetail';
import Footer from './Components/Footer';
import AllPages from './Pages/AllPages';
import {Routes,Route} from 'react-router-dom'
import Home from './Pages/Home';
import About from './Pages/About';
import Contact from './Pages/Contact';
import Students from './Pages/Students';
import Teachers from './Pages/Teachers';
import ScholarshipForm from './Pages/ScholarshipForm';
import Admitcard from './Pages/Admitcard';
// import Scholarship from './Pages/Scholarship';
// import Admitcard from './Pages/Admitcard';
import Terms from './Pages/Terms';
import Privacy from './Pages/Privacy'
import Refund from './Pages/Refund'
import Shipping from './Pages/Shipping'
import NavBar from './Components/Navb';
import TeacherDashboard from './Pages/TeacherDashboard';
import DashboardScholarship from './Pages/DashboardScholarship';
import ScholarshipPage from './Pages/ScholarshipPage';
import Dynamic from "./Components/Dynamic"

function App() {
  return (
    <div className="App">
     
      <AllPages/>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/about" element={<About/>}/>
        <Route path="/teachers" element={<Teachers/>}/>
        <Route path="/students" element={<Students/>}/>
        <Route path="/contact" element={<Contact/>}/>
        <Route path="/scholarship/form" element={<ScholarshipForm/>}/>
        <Route path='/admitcard' element={<Admitcard />}/>
        <Route path='/scholarship' element={<ScholarshipPage/>}/>
        {/* <Route path="/scholarship" element={<Scholarship/>}/>
        <Route path='/admitcard' element={<Admitcard />}/> */}
        <Route path='/terms' element={<Terms/>}/>
        <Route path='/privacy' element={<Privacy/>}/>
        <Route path='/refund' element={<Refund/>}/>
        <Route path='/shipping' element={<Shipping />}/>
        <Route path='/teachers/dashboard' element={<TeacherDashboard/>}/>
        <Route path='/teachers/dashboard/scholarship' element={<DashboardScholarship/>}/> 
      </Routes>
      <div  style={{
      position: 'fixed',
      bottom: '10px',
      right: '10px',
      zIndex:12
    }} >
       <Dynamic />
       </div>
    </div>
  );
}

export default App;
